<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      src="@/assets/img/tractor_verde_fondo.jpeg"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">RMS Uy</v-list-item-title>
            <v-list-item-subtitle>Solutions</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          @click="$vuetify.goTo(link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-15"
      :class="{ expand: flat }"
    >
      <v-toolbar-title>
        <v-img src="@/assets/img/RMSUYSolutionsLogoIcon.jpg" max-width="50px" />
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      <div v-else>
        <v-btn :class="{'mr-1':flat}" v-bind:text="!flat" @click="$vuetify.goTo('#hero')">
          <span class="">Inicio</span>
        </v-btn>
        <v-btn :class="{'mr-1':flat, 'ml-1': flat}" v-bind:text="!flat" @click="$vuetify.goTo('#features')">
          <span class="">Nosotros</span>
        </v-btn>
        <!-- <v-btn v-bind:text="!flat" @click="$vuetify.goTo('#download')">
          <span class="mr-1">Live Demo</span>
        </v-btn> -->
        <!-- <v-btn :class="{'mr-1':flat, 'ml-1': flat}" v-bind:text="!flat" @click="$vuetify.goTo('#pricing')">
          <span class="mr-1">Precios</span>
        </v-btn> -->
        <v-btn variant="tonal" v-bind:text="!flat" @click="$vuetify.goTo('#contact')">
          <span class="">Contáctenos</span>
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
  color:white !important;
}

.navBtnText{
  color: black;
}

.navBtnTextExpand{
  color: white;
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-home-outline", "Inicio", "#hero"],
      ["mdi-information-outline", "Nosotros", "#features"],
      // ["mdi-download-box-outline", "Live Demo", "#download"],
      // ["mdi-currency-usd", "Precios", "#pricing"],
      ["mdi-email-outline", "Contáctenos", "#contact"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
